import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as OrderHistoryActions from "./actions";
import type { IOrderHistoryLatestState } from "./types";

const initialState: IOrderHistoryLatestState = {
  data: null!,
  hasError: false,
  isFetching: false
};

export default function latestOrderHistoryReducer(
  state: IOrderHistoryLatestState = initialState,
  action: ActionType<typeof OrderHistoryActions>
): IOrderHistoryLatestState {
  switch (action.type) {
    case getType(OrderHistoryActions.fetchLatestOrderHistoryStart): {
      return {
        ...state,
        isFetching: true
      };
    }

    case getType(OrderHistoryActions.fetchLatestOrderHistoryFail): {
      return {
        ...state,
        hasError: true,
        isFetching: false
      };
    }

    case getType(OrderHistoryActions.fetchLatestOrderHistorySuccess): {
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    }

    default:
      return state;
  }
}
